<template>
    <data-table
        :id="state_identifier"
        :columns="visible_columns"
        :rows="filtered_rows"
        :search="state.search"
        :total="state.total"
        :found="state.found"
        :current-page="state.page"
        :total-pages="nb_pages"
        :show-totals="false"
        :searchable="false"
        table-class="lam-subrecords-list"
        empty-title="No contacts found"
        @sort="sort_by"
        @search="search"
        @page="goto_page"
        @click="record_edit(entity, $event.id)"
        class="lam-table-cell-nowrap"
    >
        <template
            v-slot:summary="{ row }"
        >
            <h6>{{ row.name }}</h6>
        </template>
        <template
            v-slot:tbody="{ row, field }"
        >
            <a v-if="field === 'main_email'" :href="row.main_email | nibnut.mailto" @click.stop>{{ row.main_email }}</a>
            <a v-else-if="field.match(/main_(phone|mobile)/)" :href="row[field] | nibnut.telto" @click.stop>{{ row[field] }}</a>
            <span v-else>{{ row[field] }}</span>
       </template>
    </data-table>
</template>

<script>
import is_remote_data_table_source from "../../mixins/IsRemoteDataTableSource"

export default {
    mixins: [is_remote_data_table_source],
    computed: {
        state_identifier () {
            return this.id
        },
        rows () {
            return this.$store.getters.entity_records(this.entity, this.current_records_ids).filter(row => {
                return row.firm_id === this.contextId
            })
        },
        visible_columns () {
            const { firm_id, ...visible_columns } = this.columns

            return visible_columns
        }
    },
    props: {
        id: {
            type: String,
            required: true
        },
        context: {
            type: String,
            required: true
        },
        contextId: {
            type: Number,
            required: true
        }
    },
    data () {
        return {
            entity: "contact",
            columns: {
                name: { label: "Name", sort: null, type: "plain", cell_class: "lam-col-name" },
                title: { label: "Title", sort: null, type: "plain" },
                main_email: { label: "Email", sort: null, type: "plain" },
                main_phone: { label: "Phone", sort: null, type: "plain" },
                main_mobile: { label: "Mobile", sort: null, type: "plain" },

                firm_id: { label: "Firm", sort: false, type: "plain" }
            },
            default_state: {
                per_page: 10,
                page: 1,
                sort_by: null,
                sort_dir: null,
                filter_on: null,
                filter: "",
                archived: false,
                search: "",
                total: 0,
                found: 0,
                context: "firm",
                context_id: this.contextId,
                activated_at: 0
            }
        }
    }
}
</script>
